import { RsCustomValidation } from "@ceeferenderer/itg-renderer-sdk";
import { email } from "./email";
import { date } from "./date";
import { confirmationNumber } from "./confirmationNumber";
import { selectValueIsTruthy } from "./selectValueIsTruthy";
import { address } from "./address";
import { accountNumber } from "./accountNumber";
import { comboDate } from "./comboDate";
import { pairDate } from "./pairDate";
import { phone } from "./phone";

RsCustomValidation.bind({
  accountNumber,
  address,
  comboDate,
  confirmationNumber,
  date,
  email,
  pairDate,
  phone,
  selectValueIsTruthy,
});
